import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { createStore } from 'vuex'
import {createRouter, createWebHashHistory} from 'vue-router'

//const app = createApp(App).use(Quasar, quasarUserOptions)
const app = createApp({}).use(Quasar, quasarUserOptions)

import settings from './store/modules/settings/';
import values from './store/modules/values/';
import lo from './store/modules/lo/';
import Login from "@/components/LoginComponent";
import RegisterComponent from "@/components/RegisterComponent";
import vue3GoogleLogin from 'vue3-google-login'
import ItemsComponent from "@/components/ItemsComponent";
import LogoutComponent from "@/components/LogoutComponent";
import {initReCaptcha} from "@/helpers/recaptcha";
import PasswordResetComponent from "@/components/PasswordResetComponent";

const store = createStore({
    modules: {
        settings,
        values,
        lo
    }
})

app.use(store);

const routes = [
    { path: '/', component: App, name: 'MortgageWare' },
    { path: '/login', component: Login, name: 'Sign In'  },
    { path: '/forgot-password', component: PasswordResetComponent, name: 'Forgot password'  },
    { path: '/logout', component: LogoutComponent, name: 'Logout'  },
    { path: '/signup', component: RegisterComponent, name: 'Sign Up'  },
    { path: '/forms', component: ItemsComponent, name: 'Dashboard' },
    { path: '/forms/:id', component: App, name: 'My form' },
    { path: '/config', component: App, name: 'Config', props: { mode_config: true } },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHashHistory(),
    routes, // short for `routes: routes`
})
router.beforeEach((to, from, next) => {
    document.title = to.name;
    next();
});
app.use(router)

app.use(vue3GoogleLogin, {
    clientId: '308703078846-43jc22jptka3od4g7ja9nthsvn098v2g.apps.googleusercontent.com' //YOUR_GOOGLE_CLIENT_ID
})

initReCaptcha(app);

app.mount('#formbuilder');

export { app, router, store }

